import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from './Spinner';
import { TablePageSkeleton } from '../skeletons';
import './GlobalLoader.css';

export interface GlobalLoaderProps {
  /** The text to display below the loader */
  text?: string;
  /** The type of loader to display: standard spinner or full page skeleton */
  type?: 'spinner' | 'skeleton';
  /** How to align the loader within its container */
  align?: 'center' | 'top' | 'fill';
  /** Optional custom CSS class */
  className?: string;
}

/**
 * Unified GlobalLoader component for consistent loading states across the platform.
 * 
 * Replaces disparate loaders (sand clocks, inline texts, disparate skeletons) 
 * with a single standardized component.
 */
export const GlobalLoader: React.FC<GlobalLoaderProps> = (props) => {
  const { t } = useTranslation()
  const {
    text = t('registry.common.loading', 'Loading...'),
    type = 'spinner',
    align = 'fill',
    className = '',
  } = props;

  if (type === 'skeleton') {
    return (
      <div className={`global-loader global-loader--skeleton ${className}`}>
        <TablePageSkeleton />
      </div>
    );
  }

  const alignClass = `global-loader--align-${align}`;

  return (
    <div className={`global-loader ${alignClass} ${className}`}>
      <div className="global-loader__content">
        <Spinner size="lg" className="global-loader__spinner" />
        {text && <span className="global-loader__text">{text}</span>}
      </div>
    </div>
  );
};
